import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { cardDetailResModel } from 'src/app/home/models/cardBalanceResponse.model';

@Component({
  selector: 'app-card-pending-check',
  templateUrl: './card-pending-check.component.html',
  styleUrls: ['./card-pending-check.component.scss', '../../../../home/home.component.scss']
})
export class CardPendingCheckComponent implements OnInit {
  @Input() card!: cardDetailResModel;
  @Input() favorite!:string;

  constructor(private toastr: ToastrService) { }

  ngOnInit(): void {
  }

  onClick_PendingChargeDetail(message:any) {
    this.toastr.info(
      message
    );
  }

}
